module.exports = __webpack_public_path__ + "static/media/hotels-armenia.311b2c52.jpg";